export default __webpack_public_path__ + "static/4-ffcb75e26639aee51cd0c24a87b0653f.jpg";